{
    "title": "التكاملات",
    "subtitle": "كل ما يتصل به هذا النظام، وهل يعمل أم لا.",
    "add": "إضافة موصّل",
    "category": "الفئة",
    "connector": "الموصّل",
    "configure": "الإعداد",
    "test": "اختبار",
    "retry": "إعادة المحاولة",
    "enabled": "مُفعّل",
    "disabled": "معطّل",
    "enable": "مُفعّل",
    "offshore": "البيانات تغادر عُمان",
    "offshore_help": "فعّل هذا إن كانت البيانات المتبادلة مع هذا النظام تعبر الحدود. هذا قرار امتثال، ومكانه بجوار الموصّل لا في وثيقة.",
    "driver_missing": "الموصّل غير متوفر",
    "key": "المُعرّف",
    "name_en": "الاسم (بالإنجليزية)",
    "name_ar": "الاسم (بالعربية)",
    "timeout": "المهلة (ثوانٍ)",
    "rate_limit": "حد الطلبات (في الدقيقة)",
    "rate_limit_help": "اتركه فارغاً لعدم التحديد. النظام الذي يتعطل عند عشرين طلباً في الثانية حادثة تشغيلية نحن سببها.",
    "max_attempts": "محاولات الإرسال",
    "connector_settings": "إعدادات الموصّل",
    "operation": "العملية",
    "attempts": "المحاولات",
    "error": "الخطأ",
    "status": "الحالة",
    "when": "التوقيت",
    "calls_24h": "الطلبات (٢٤ ساعة)",
    "success_rate": "نسبة النجاح",
    "mean_ms": "المتوسط",
    "last_checked": "آخر فحص",
    "recent_failures": "الإخفاقات الأخيرة",
    "no_failures": "لم يخفق شيء.",
    "logs_permission": "لا تملك صلاحية قراءة سجلات التكامل.",
    "categories": {
        "core_banking": "الأنظمة الأساسية",
        "messaging": "المراسلة",
        "identity": "الهوية",
        "analytics": "التحليلات",
        "telephony": "الاتصال الهاتفي",
        "storage": "التخزين",
        "government": "الجهات الحكومية والرقابية"
    },
    "drivers": {
        "core_banking": "النظام المصرفي الأساسي",
        "loan_origination": "نظام إنشاء التمويل",
        "sms": "بوابة الرسائل النصية",
        "email": "البريد الإلكتروني",
        "whatsapp": "واتساب للأعمال",
        "telephony_bridge": "الاتصال الهاتفي",
        "directory": "الدليل (LDAP / SAML / OIDC)",
        "data_warehouse": "مستودع البيانات",
        "object_storage": "تخزين الملفات",
        "regulatory": "تقارير البنك المركزي"
    },
    "channels": {
        "sms": "رسالة نصية",
        "email": "بريد إلكتروني",
        "whatsapp": "واتساب"
    },
    "health": {
        "healthy": "يعمل",
        "degraded": "يتعثر أحياناً",
        "unhealthy": "لا يعمل",
        "misconfigured": "يحتاج إلى إعداد",
        "unknown": "لم يُفحص بعد"
    },
    "health_column": "الحالة",
    "health_page": {
        "title": "حالة التكاملات",
        "subtitle": "ما يعمل، وما هو متوقف، ومن لم يُبلَّغ.",
        "connectors": "الموصّلات",
        "dead_letters_one": "رسالة واحدة تعذّر إرسالها وتوقفت المحاولات. هناك من لم يُبلَّغ بشيء.",
        "dead_letters_other": "{{count}} رسالة تعذّر إرسالها وتوقفت المحاولات. هذا عدد من لم يُبلَّغوا بشيء."
    },
    "outbox": {
        "title": "صندوق الصادر",
        "empty": "لا يوجد شيء هنا.",
        "status": {
            "pending": "بالانتظار",
            "dispatching": "جارٍ الإرسال",
            "delivered": "تم الإرسال",
            "dead_letter": "تعذّر الإرسال"
        }
    },
    "form": {
        "no_fields": "هذا الموصّل لا يحتاج إلى إعداد.",
        "secret_set": "محفوظ",
        "secret_unchanged": "اتركه فارغاً للإبقاء على القيمة الحالية",
        "secret_blank_keeps": "اتركه فارغاً للإبقاء على المحفوظ. لا يمكن لأي شاشة عرض القيمة الحالية.",
        "secret_rotated_at": "آخر تغيير في {{date}}. اتركه فارغاً للإبقاء عليه."
    },
    "webhooks": {
        "title": "الويب هوك",
        "subtitle": "ما ترسله الأنظمة الأخرى إلينا، وماذا حدث له.",
        "new": "نقطة جديدة",
        "slug": "المسار",
        "url": "الرابط الذي يُعطى للنظام المرسِل",
        "signing_secret": "مفتاح التوقيع",
        "secret_required_help": "إلزامي. النقطة بلا مفتاح ترفض كل طلب — وهو التصرف الصحيح، لكنه يبدو عطلاً لا نقصاً في الإعداد.",
        "timestamp_header": "ترويسة الطابع الزمني",
        "timestamp_help": "اختياري. بدونها لا ينتهي صلاحية التوقيع أبداً، ويستطيع من رأى طلباً واحداً إعادة إرساله متى شاء.",
        "tolerance": "السماحية (ثوانٍ)",
        "algorithm": "الخوارزمية",
        "header": "ترويسة التوقيع",
        "received": "المستلَم",
        "rotate": "توليد مفتاح جديد",
        "secret_once": "هذه المرة الوحيدة التي يُعرض فيها المفتاح. انسخه إلى النظام المرسِل الآن.",
        "no_secret": "لا يوجد مفتاح توقيع",
        "deliveries": "الرسائل الواردة",
        "no_deliveries": "لم يصل شيء بعد.",
        "endpoint": "النقطة",
        "event": "الحدث",
        "replay": "إعادة التشغيل",
        "statuses": {
            "received": "مقبول",
            "processed": "تمت المعالجة",
            "rejected": "مرفوض"
        },
        "rejections": {
            "signature_mismatch": "توقيع غير صحيح",
            "signature_missing": "لا يوجد توقيع",
            "no_signing_secret": "لا يوجد مفتاح مهيأ",
            "timestamp_outside_tolerance": "انتهت صلاحية الطابع الزمني",
            "ip_not_allowed": "عنوان غير مسموح",
            "endpoint_inactive": "النقطة معطّلة"
        }
    },
    "keys": {
        "title": "مفاتيح الواجهة",
        "subtitle": "بيانات اعتماد تطبيق الجوال وغيره من الأنظمة المتصلة.",
        "new": "مفتاح جديد",
        "create": "إنشاء المفتاح",
        "name": "الاسم",
        "prefix": "البادئة",
        "scopes": "النطاقات المسموحة",
        "all_scopes": "كل النطاقات",
        "requests": "الطلبات",
        "last_used": "آخر استخدام",
        "never_used": "لم يُستخدم",
        "expires": "تاريخ الانتهاء",
        "expiry_help": "المفتاح بلا تاريخ انتهاء يبقى بعد انتهاء المشروع الذي أُنشئ له.",
        "revoke": "إلغاء",
        "revoked": "ملغى",
        "empty": "لا توجد مفاتيح بعد.",
        "shown_once": "هذه المرة الوحيدة التي يُعرض فيها مفتاح «{{name}}». انسخه الآن."
    },
    "simulators": {
        "title": "المحاكيات",
        "subtitle": "كيف يتصرف النظام دون أي نظام خارجي مهيأ — وهو نفس تصرفه يوم يتعطل أحدها.",
        "messages": "سجل الرسائل",
        "inbound": "البريد الوارد",
        "directory": "الدليل",
        "send": "إرسال رسالة تجريبية",
        "send_help": "تمر عبر صندوق الصادر والموزّع والموصّل الحقيقي — لا مباشرة إلى السجل. ما يُثبَت هو المسار كاملاً.",
        "channel": "القناة",
        "recipient": "إلى",
        "subject": "الموضوع",
        "body": "الرسالة",
        "log": "ما أُرسل",
        "no_messages": "لم يُرسل شيء بعد.",
        "segments_one": "جزء واحد، {{encoding}}",
        "segments_other": "{{count}} أجزاء، {{encoding}} — الرسالة العربية تحمل ٧٠ حرفاً لكل جزء لا ١٦٠، والمشغّل يحاسب على كل جزء.",
        "deliver": "التسليم إلى الصندوق",
        "from": "من",
        "from_help": "استخدم بريد أحد العملاء المسجّلين لترى شكوى تُنشأ، أو أي بريد آخر لترى الرفض.",
        "subject_help": "أدرج رقم شكوى ليُضاف النص إلى الشكوى القائمة بدل إنشاء شكوى جديدة.",
        "outcome": "ما حدث",
        "no_outcome": "سلّم رسالة لترى ما يفعله النظام بها.",
        "actions": {
            "created": "أُنشئت شكوى",
            "appended": "أُضيفت إلى الشكوى القائمة",
            "unmatched_sender": "لا يوجد عميل مطابق",
            "ignored_empty": "أُهملت — بلا محتوى"
        },
        "unmatched_explained": "لا يحمل أي عميل هذا البريد، فلم يُنشأ شيء. إنشاء عميل من عنوان مرسِل يملأ سجل العملاء بأسماء وهمية من القوائم البريدية والردود الآلية.",
        "matched_explained": "طوبق المرسِل بسجل العملاء، فأصبحت الشكوى على المسار الزمني الواحد لذلك الشخص بجانب مكالماته وزياراته واستبياناته.",
        "directory_users": "الدليل المُهيأ",
        "shared_password": "كل الحسابات المحاكاة تستخدم كلمة المرور «{{password}}».",
        "sign_in": "تسجيل الدخول",
        "username": "اسم المستخدم",
        "password": "كلمة المرور",
        "groups": "مجموعات الدليل",
        "roles": "الأدوار الممنوحة",
        "admitted": "سيُسمح لهذا الشخص بالدخول بالأدوار أعلاه.",
        "not_admitted": "بيانات الدخول صحيحة، لكن لا توجد مجموعة مرتبطة بدور — فالشخص موثَّق ومرفوض في الوقت نفسه."
    }
}
